"use client"

import { useCountry } from "@/components/layout/country-provider"
import { ShieldCheckIcon, SwissShieldIcon } from "@/components/ui/icons"

/**
 * Icon for the "trusted partner" value on /about. AT gets a neutral check
 * shield, since the Swiss cross reads as a Swiss coat of arms there
 * (AHD-14015, same swap as `ReviewedByPhysiciansIcon`); every other market
 * keeps the Swiss shield.
 */
export function TrustedPartnerIcon({
  className,
  size = 22,
}: {
  className?: string
  size?: number
}) {
  const { code } = useCountry()
  const Icon = code === "at" ? ShieldCheckIcon : SwissShieldIcon
  return <Icon className={className} size={size} />
}
